import classnames from 'classnames/bind'

// Libs

// Components

// Constants

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface ItemProps {
  className?: string
  label: string
  value: string
  isDisabled: boolean
  handleItemClick: ({ value, isDisabled }: { value: string; isDisabled: boolean }) => void
}

const Item = (props: ItemProps) => {
  const { className, label, value, isDisabled, handleItemClick } = props

  return (
    <div className={cx('item', className, { isDisabled })} onClick={() => handleItemClick({ value, isDisabled })}>
      {label}
    </div>
  )
}

export default Item
